"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UINavItemLabel = _interopRequireDefault(require("../nav/UINavItemLabel"));

var _decorators = require("../utils/propTypes/decorators");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _renderProp = require("../utils/propTypes/renderProp");

var _times = require("HubStyleTokens/times");

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _misc = require("HubStyleTokens/misc");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-grow: 1;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: ", ";\n  margin-right: ", ";\n\n  &.private-icon.private-icon__low {\n    margin-right: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n  left: -", ";\n  line-height: 16px;\n  padding: ", " ", " ", "\n    ", ";\n  position: relative;\n  text-decoration: none;\n  width: calc(100% + ", ");\n\n  ", "\n  ", "\n  ", "\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    z-index: ", "\n  }\n\n  .private-tag--unenclosed {\n    line-height: 16px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  user-select: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  color: ", ";\n  cursor: pointer;\n  text-decoration: none;\n  :not(.private-folder-nav-item) {\n    background-color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  background-color: ", ";\n  font-weight: ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: -", ";\n  padding-left: ", ";\n  overflow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ICON_SIZE = 'xxs';
var NavListItemTransitionWrapper = (0, _styledComponents.default)(_AccordionTransition.default.defaultProps.Wrapper).withConfig({
  displayName: "UINavListItem__NavListItemTransitionWrapper",
  componentId: "sc-14trkhi-0"
})(_templateObject(), _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'hidden' : 'visible';
});
var activeStyles = (0, _styledComponents.css)(_templateObject2(), _theme.BASE_FONT_COLOR, _theme.SIDENAV_SELECTED_BACKGROUND_COLOR, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, (0, _Styles.setBorderRadius)());
var hoveredStyles = (0, _styledComponents.css)(_templateObject3(), (0, _Styles.setBorderRadius)(), _theme.BASE_FONT_COLOR, _theme.SIDENAV_HOVERED_BACKGROUND_COLOR);
var parentStyles = (0, _styledComponents.css)(_templateObject4());
var StyledLink = (0, _styledComponents.default)(function (props) {
  var Link = props.linkComponent,
      __active = props.active,
      __hasChildren = props.hasChildren,
      __hovered = props.hovered,
      rest = (0, _objectWithoutProperties2.default)(props, ["linkComponent", "active", "hasChildren", "hovered"]);
  return _react.default.createElement(Link, rest);
}).withConfig({
  displayName: "UINavListItem__StyledLink",
  componentId: "sc-14trkhi-1"
})(_templateObject5(), (0, _Styles.setFontSmoothing)('auto'), _Styles.FONT_FAMILIES.default, (0, _Styles.setFontSize)(_sizes.BASE_FONT_SIZE), _theme.SIDENAV_FOREGROUND_COLOR, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_Y, _sizes.NAV_ITEM_PADDING_RIGHT, _sizes.NAV_ITEM_PADDING_Y, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, function (_ref2) {
  var active = _ref2.active;
  return active ? activeStyles : undefined;
}, function (_ref3) {
  var hovered = _ref3.hovered;
  return hovered ? hoveredStyles : undefined;
}, function (_ref4) {
  var hasChildren = _ref4.hasChildren;
  return hasChildren ? parentStyles : undefined;
}, hoveredStyles, _sizes.MERCURY_LAYER);
var Icon = (0, _styledComponents.default)(function (props) {
  var __hasChildren = props.hasChildren,
      rest = (0, _objectWithoutProperties2.default)(props, ["hasChildren"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UINavListItem__Icon",
  componentId: "sc-14trkhi-2"
})(_templateObject6(), function (_ref5) {
  var placement = _ref5.placement;
  return placement === 'left' && '0';
}, _sizes.NAV_ITEM_INNER_SPACING_X, function (_ref6) {
  var placement = _ref6.placement;
  return placement === 'right' && '0 !important';
}, function (_ref7) {
  var hasChildren = _ref7.hasChildren,
      placement = _ref7.placement;
  return (hasChildren && placement === 'right' ? _theme.BASE_LINK_COLOR : _colors.CALYPSO) + " !important}";
});
var NavItemLabel = (0, _styledComponents.default)(_UINavItemLabel.default).withConfig({
  displayName: "UINavListItem__NavItemLabel",
  componentId: "sc-14trkhi-3"
})(_templateObject7());

var UINavListItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UINavListItem, _Component);

  function UINavListItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UINavListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UINavListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onOpenChange = _this$props.onOpenChange,
          open = _this$props.open;
      if (onClick) onClick(evt);

      if (!evt.defaultPrevented) {
        onOpenChange((0, _SyntheticEvent.default)(!open));
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UINavListItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          active = _this$props2.active,
          children = _this$props2.children,
          className = _this$props2.className,
          count = _this$props2.count,
          duration = _this$props2.duration,
          __hovered = _this$props2.hovered,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          itemClassName = _this$props2.itemClassName,
          linkComponent = _this$props2.linkComponent,
          __onBlur = _this$props2.onBlur,
          __onClick = _this$props2.onClick,
          __onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          _rootRenderer = _this$props2._rootRenderer,
          title = _this$props2.title,
          __value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["active", "children", "className", "count", "duration", "hovered", "iconLeft", "iconRight", "itemClassName", "linkComponent", "onBlur", "onClick", "onOpenChange", "open", "_rootRenderer", "title", "value"]);

      var renderIcon = function renderIcon(icon, placement) {
        if (!icon) return null;

        if (_react.default.isValidElement(icon)) {
          return icon;
        }

        if (typeof icon === 'function') {
          return icon({
            children: children,
            open: open,
            size: ICON_SIZE,
            placement: placement
          });
        }

        return _react.default.createElement(Icon, {
          name: icon,
          size: ICON_SIZE,
          placement: placement,
          hasChildren: children !== null
        });
      };

      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        var classes = (0, _classnames.default)(className, 'private-nav-item', {
          'private-nav-item--active': active
        });
        return _react.default.createElement("li", {
          className: itemClassName
        }, _react.default.createElement(StyledLink, (0, _extends2.default)({
          active: active,
          hasChildren: (0, _renderProp.isRenderable)(children),
          hovered: hovered || undefined,
          linkComponent: linkComponent
        }, rest, hoverProviderRestProps, {
          "aria-current": active ? 'true' : null,
          className: classes,
          onClick: _this2.handleClick
        }), renderIcon(iconLeft, 'left'), _react.default.createElement(NavItemLabel, {
          count: count
        }, title), renderIcon(iconRight, 'right')), _react.default.createElement(_AccordionTransition.default, {
          open: open,
          duration: duration,
          Wrapper: NavListItemTransitionWrapper
        }, children && _rootRenderer && _rootRenderer(children)));
      });
    }
  }]);
  return UINavListItem;
}(_react.Component);

UINavListItem.propTypes = {
  active: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  count: _propTypes.default.node,
  duration: _propTypes.default.number,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  iconLeft: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  iconRight: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  itemClassName: _propTypes.default.string,
  linkComponent: _component.default,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired,
  value: _propTypes.default.node,
  _rootRenderer: _propTypes.default.func
};
UINavListItem.defaultProps = {
  active: false,
  duration: parseInt(_times.NAV_LIST_TRANSITION_ANIMATION_TIMING, 10),
  linkComponent: _UILink.default,
  open: false
};
UINavListItem.displayName = 'UINavListItem';

var _default = (0, _Controllable.default)(UINavListItem, ['open']);

exports.default = _default;
module.exports = exports.default;